<template>
<div class="footer">
  <div>
    <strong>Copyright</strong> Locadados Data Solutions &copy; 2008-{{ new Date().getFullYear() }}
  </div>
</div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>
